import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';
import {userLogout,forbiddenAccess} from  './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION)
    .use(function(req) {
        req.on('response', function (res) {
            if (res.status === 401) {
            console.log('UnAuthorized');
              userLogout();
                
            }else if(res.status === 403){
              console.log('Forbidden');
              forbiddenAccess();
            }
        });
});

export function getVoicemailsStart() {
  return {
    type: types.GET_VOICEMAILS_START,
  };
}

export function getVoicemailsSuccess({ voicemails }) {
  return {
    type: types.GET_VOICEMAILS_SUCCESS,
    voicemails,
  };
}

export function getVoicemailsFail() {
  return {
    type: types.GET_VOICEMAILS_FAIL,
  };
}

export function getVoicemails({ startDate, endDate }) {
  return (dispatch) => {
    dispatch(getVoicemailsStart());
    const params = Object.assign({}, {
      minDate: startDate,
      maxDate: endDate,
    });

    request.get(`${window.Config.API_URL}/business/vmLogs`).withCredentials().set('X-Request-ID', uuidv4())
      .query(params)
      .then((resp) => {
        dispatch(getVoicemailsSuccess({ voicemails: resp.body }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getVoicemailsFail());
      });
  };
}

export function markVoicemailStart() {
  return {
    type: types.MARK_VOICEMAIL_START,
  };
}

export function markVoicemailSuccess({ id, isRead }) {
  return {
    type: types.MARK_VOICEMAIL_SUCCESS,
    id,
    isRead,
  };
}

export function markVoicemailFail() {
  return {
    type: types.MARK_VOICEMAIL_FAIL,
  };
}

export function markVoicemail({ id, isRead }) {
  return (dispatch, getState) => {
    dispatch(markVoicemailStart());

    const { auth } = getState();
    const params = Object.assign({}, {
      query: auth.userid,
      logId: id,
      isRead,
    });

    request.post(`${window.Config.API_URL}/business/vmLogs/mark`).withCredentials().set('X-Request-ID', uuidv4())
      .send(params)
      .then(() => {
        dispatch(markVoicemailSuccess({ id, isRead }));
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(markVoicemailFail());
      });
  };
}
